import * as cafeMenusCoordinators from './menus'

export default Object.freeze({
  ...cafeMenusCoordinators,
})
